import type { EMeetingStatus } from "./meetings";

export interface ITranscriptEntry {
  start: number;
  speaker: string;
  text: string;
}

export enum EMediaAvailability {
  AVAILABLE = "available",
  PROCESSING = "processing",
  UNAVAILABLE = "unavailable",
}

export enum EMediaType {
  AUDIO = "audio",
  VIDEO = "video",
  // NOTE: NSAI-3847 — "Download all": the recording, the summary and the
  // transcript packed into a single .zip. Tracked like any other download (one
  // progress ring, one cancel) because the recording is what takes the time.
  BUNDLE = "bundle",
}

export interface IStructuredNote {
  time_start: string;
  time_end: string;
  theme: string;
  emoji?: string;
  points: string[];
}

export interface INotesTimeEntry {
  timeRange: string;
  points: string[];
}

export interface IGroupedNotesByThemeItem {
  theme: string;
  emoji?: string;
  timeEntries: INotesTimeEntry[];
}

export interface ISimpleActionItem {
  time_start: string;
  time_end: string;
  description: string;
}

export interface ILegacyActionItemsSection {
  section: string;
  timeRange: string;
  items: string[];
}

export interface IGetLanguageDisplayNameParams {
  language: string;
  t: (key: string) => string;
}

export interface IParseStructuredNotesParams {
  notes: unknown;
  fallback: string;
}

export interface IFormatSecondsToDurationLabelProps {
  seconds: number;
}

export interface IGetShouldShowShortMeetingMessageProps {
  status: EMeetingStatus;
  secondsConsumed: number;
  notes: unknown;
  transcript: string | null;
}

export interface IGetDurationDisplayProps {
  secondsConsumed: number;
}

// NOTE: Callbacks the "video is still processing" poll loop reports through.
// `checkAvailability` re-asks the server (both players already own a function
// that also refreshes the stream URL as a side effect), and exactly one of
// `onAvailable` / `onUnavailable` fires before the loop stops.
export interface IStartVideoProcessingPollParams {
  checkAvailability: () => Promise<EMediaAvailability>;
  onAvailable: () => void;
  onUnavailable: () => void;
}
